import { CommandDispatcher } from "@/modules/shared/domain/CommandDispatcher";

export class DeleteTransactions {
  constructor(
    private readonly dispatcher: CommandDispatcher,
    private readonly frontend,
  ) { }

  async run(transaction_ids:[string], idBankAccount:String|Number, listFilters?): Promise<any> {
    let args = { 
      transaction_ids: transaction_ids
    }
    this.frontend.loading_delete_transactions(true)
    let res = await this.dispatcher.dispatch('delete_transaction.data', args)
    this.frontend.deleteTransactionsJobState = 'running';
    this.frontend.deleteTransactionsJobId = res.job_id
    this.frontend.showDeleteTransactionsPupup = false
    this.frontend.loading_delete_transactions(false)
  }
}